import { COLORS, pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';
import { Button } from '@/ui';

export const StyledFooter = styled.footer`
  padding: 2rem;
  border-top: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  background-color: ${pickThemeColor('BG_SECONDARY')};
  position: sticky;
  bottom: 0;
  display: flex;
  justify-content: center;
  margin-top: auto;
`;

export const StyledContainer = styled.div`
  padding: 0 1.75rem 1.75rem 1.75rem;
`;

export const StyledDocumentsContainer = styled.div`
  padding: 0 1.75rem 1.75rem 1.75rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const StyledDocumentsFooter = styled.div`
  display: flex;
  gap: 1rem;
  padding: 2rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${COLORS.BG_SECONDARY};
  border-top: 1px solid ${COLORS.LIGHT_PURPLE};
`;

export const StyledNoteMessage = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '20')};

  span {
    cursor: pointer;
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    text-decoration: underline;
    ${pickThemeFontStyles('16', '24')};

    &:hover {
      color: ${pickThemeColor('ORANGE_PRIMARY')};
      text-decoration: none;
    }
  }
`;

export const StyledSubmitButton = styled(Button)`
  width: fit-content;
  ${pickThemeFontStyles('16', '20', 'SEMI_BOLD')};
`;
